import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';

export const resolveErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof ApiCallError ? getApiCallErrorMessage(error) : fallback;
